import React from 'react'
import { Button, Modal } from 'react-bootstrap'
import project_10 from '../../assets/images/projects/project_10.svg'
import project_11 from '../../assets/images/projects/project_11.svg'
import project_12 from '../../assets/images/projects/project_12.svg'
import project_4 from '../../assets/images/projects/project_4.png'
import project_6 from '../../assets/images/projects/project_6.png'
import project_8 from '../../assets/images/projects/project_8.png'

class OurProjects extends React.Component {
    constructor() {
        super()

        this.state = {
            show: false,
            project: '',
        }
    }

    modalContent = () => {
        if (this.state.project === 'project_4') {
            return (
                <>
                    <p>METEOPROG - one of the first projects of the weather forecast sites emerged in the post-soviet area with the coverage of more than 170 countries worldwide.</p>
                    <span>Features:</span>
                    <ul>
                        <li>real-time information about the weather forecast;</li>
                        <li>coverage of more than 170 countries and around 15000 cities and places worldwide;</li>
                        <li>usage of a highly effective WRF model (Weather Research and Forecasting), which provides accurate numerical weather prediction data;</li>
                        <li>tconstant development and improvement of weather forecast calculation models, which allows to increase the amount of covered cities and improve the accuracy of weather forecasts.</li>
                    </ul>
                </>
            )
        } else if (this.state.project === 'project_6') {
            return (
                <>
                    <p>GoAdvert - is a special ad-network tool for those who are looking to scale their advertising strategy from one website to a network of multiple publishers. GoAdvert can help to start the ad network of publishers and advertisers.</p>
                    <span>Features:</span>
                    <ul>
                        <li>simultaneous operation of multiple websites;</li>
                        <li>live ad performance reports issuing and broken down by each website;</li>
                        <li>own ad network creation with partner programme;</li>
                        <li>customization of modules and features;</li>
                        <li>the possibility of geographic targeting provides wide opportunities for advertising in 50+ countries, as well as in local regions or cities.</li>
                        <li>a variety of formats of advertising placed - branding, banners, pre-rolls and so on.</li>
                        <li>multi-level analytics, which allows the customer to get statistics, and visualize it for each element of the advertising campaign.</li>
                    </ul>
                </>
            )
        } else if (this.state.project === 'project_8') {
            return (
                <>
                    <p>Sport Solutions is a platform that displays sports statistics, news and video content of various sports with the possibility of advertisement placement. It provides a full cycle of processing and output information with monetization through advertising.</p>
                    <span>Features:</span>
                    <ul>
                        <li>display of sports statistics/events/games/ news and video content;</li>
                        <li>the ability to select the display for various sports, teams, champions, players by country, multilingualism;</li>
                        <li>historical data, selection of display with results of sports events by days;</li>
                        <li>flexible settings for news and video content display;</li>
                        <li>a wide range of tools on platform administration / moderation.</li>
                        <li>placement of advertisements on the  Sport Solutions platform, customization of interface and analytics.</li>
                    </ul>
                </>
            )
        } else if (this.state.project === 'project_10') {
            return (
                <>
                    <p>
                        Foot Africa is the leading football portal in Africa, delivering up-to-date football news,
                        analysis, and community-driven content focused on African, European, and international football.
                        The platform connects millions of fans through rich editorial content and social engagement.
                    </p>
                    <span>Features:</span>
                    <ul>
                        <li>football news coverage across African, European, and international competitions;</li>
                        <li>multilingual content in French, Arabic, and English;</li>
                        <li>real-time updates, match results, and in-depth editorial analysis;</li>
                        <li>interactive community features allowing fans to share opinions and engage in discussions;</li>
                        <li>a wide network of correspondents across Africa and worldwide;</li>
                        <li>strong social media integration with a large and active football fan community.</li>
                    </ul>
                </>
            )
        } else if (this.state.project === 'project_11') {
            return (
                <>
                    <p>
                        Cargofy is a technology-driven logistics platform that uses artificial intelligence to connect truck owners and carriers with freight loads in real time. Its AI dispatching tools automate load matching, route planning, delivery tracking, and other fleet management tasks, helping carriers reduce idle time and optimize operations while giving shippers immediate access to multiple transport options.
                    </p>
                    <span>Features:</span>
                    <ul>
                        <li>AI-Powered Load Matching;</li>
                        <li>automated Dispatch and Fleet Management;</li>
                        <li>trip Coordination & Delivery Tracking;</li>
                        <li>route Planning & Optimization;</li>
                        <li>real-Time Bidding & Load Boards Access.</li>
                    </ul>
                </>
            )
        } else if (this.state.project === 'project_12') {
            return (
                <>
                    <p>
                        Lasta is a wellness and healthy-weight-loss mobile app designed to support users in achieving sustainable lifestyle goals by combining science-based nutrition, intermittent fasting, habit tracking, and fitness tools.
                    </p>
                    <span>Features:</span>
                    <ul>
                        <li>custom fasting schedules and progress monitoring;</li>
                        <li>track meals, calories, and dietary habits;</li>
                        <li>tools to monitor weight, mood, water intake, and steps;</li>
                        <li>workouts such as yoga and pilates tailored to user goals;</li>
                        <li>wellness lessons, expert insights, and health guidance.</li>
                    </ul>
                </>
            )
        }
    }

    handleClose = () => {
        this.setState({ show: false })
    }

    handleOpen = project => {
        this.setState({ show: true })
        this.setState({ project: project })
    }

    render() {
        return (
            <section id='our-projects' className="our-projects ptb-1">
                <div className="container">
                    <div className="section-title">
                        <h2><span>CURRENT</span> PROJECTS</h2>
                        <div className="row">
                            <div className="col-lg-4 col-md-6">
                                <div className='project-item'>
                                    <img src={project_4} alt="project-pic" />
                                    <p>One of the first projects of the weather forecast sites emerged in the
                                        post-soviet area with the coverage of more than 170 countries worldwide.</p>
                                    <Button onClick={() => this.handleOpen('project_4')}>+</Button>
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-6">
                                <div className='project-item'>
                                    <img src={project_6} alt="project-pic" />
                                    <p>GoAdvert can help to start the ad network of publishers and advertisers.</p>
                                    <Button onClick={() => this.handleOpen('project_6')}>+</Button>
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-6">
                                <div className='project-item'>
                                    <img src={project_8} alt="project-pic" />
                                    <p>The Sport Solutions platform is an all-in-one solution for development of own sports statistics, news and video content websites.</p>
                                    <Button onClick={() => this.handleOpen('project_8')}>+</Button>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-4 col-md-6">
                                <div className='project-item'>
                                    <img src={project_10} alt="project-pic" />
                                    <p>Foot Africa, the No. 1 football portal in Africa!</p>
                                    <Button onClick={() => this.handleOpen('project_10')}>+</Button>
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-6">
                                <div className='project-item'>
                                    <img src={project_11} alt="project-pic" />
                                    <p>Intelligent fleet management with AI agents</p>
                                    <Button onClick={() => this.handleOpen('project_11')}>+</Button>
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-6">
                                <div className='project-item'>
                                    <img src={project_12} alt="project-pic" />
                                    <p>Lasta App: Your Guide to Sustainable and Healthy Weight Loss</p>
                                    <Button onClick={() => this.handleOpen('project_12')}>+</Button>
                                </div>
                            </div>
                        </div>
                        <Modal size='lg' show={this.state.show} onHide={() => this.handleClose()}>
                            <Modal.Body>{this.modalContent()}</Modal.Body>
                            <Modal.Footer className='text-center'>
                                <Button style={{ color: '#182848', borderColor: '#182848' }} variant='outline' onClick={() => this.handleClose()}>
                                    X
                                </Button>
                            </Modal.Footer>
                        </Modal>
                    </div>
                </div>
            </section>
        )
    }
}

export default OurProjects